import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, paginate } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import useAxios from '@/services/api/useAxios'

const resource = 'contractSuperTypes'

const getOne = (axios: IFactoryFunctionRequest<any, any>) => (processId: string) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${processId}`,
  })
}

const filter = (axios: IFactoryFunctionRequest<paginate<{ display: string }>, any>) => (query: { page: number; limit: number; search?: string }) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/filter`,
    query,
  })
}

const updateContractSuperType = (axios: IFactoryFunctionRequest<any, any>) => (id, { data }) => {
  return axios({
    method: EMethod.patch,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/update/${id}`,
    data,
  })
}

const createContractSuperType = (axios: IFactoryFunctionRequest<any, any>) => (data) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/create`,
    data,
  })
}

const deleteContractSuperType = (axios: IFactoryFunctionRequest<any, any>) => (id: string) => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/delete/${id}`,
  })
}

export default (axios: AxiosInstance) => ({
  filter: filter(useAxios(axios)),
  getOne: getOne(useAxios(axios)),
  update: updateContractSuperType(useAxios(axios)),
  create: createContractSuperType(useAxios(axios)),
  delete: deleteContractSuperType(useAxios(axios)),
})
